import { Input } from '@frontend/shadcn/components/ui/input';
import { CircleCheckIcon } from '@revfluence/fresh-icons/solid/esm';
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@frontend/shadcn/components/ui/accordion';
import { RichTextEditor } from '@frontend/app/refresh-components';
import { useRecruitment, useConfirmationPage } from '../RecruitmentContext';

export const ConfirmationPage = () => {
  const {
    setConfirmationPrimaryMessage,
    setConfirmationDescription,
  } = useRecruitment();

  const confirmationPage = useConfirmationPage();

  if (!confirmationPage) {
    return null;
  }

  const {
    primaryMessage,
    description,
  } = confirmationPage;

  return (
    <Accordion type="multiple" className="[&_h3]:mb-0" defaultValue={['hero']}>
      <AccordionItem value="hero" className="border-b-0">
        <AccordionTrigger>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-lime-5 rounded-lg text-primary-foreground flex items-center justify-center">
              <CircleCheckIcon fontSize={12} />
            </div>
            <span className="text-base font-medium">Confirmation</span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="pb-0">
          {/* Title Section */}
          <div className="flex flex-col gap-2">
            <label htmlFor="confirmationPageTitle" className="text-xs font-medium text-foreground">Primary Message</label>
            <div className="px-[1px]">
              <Input id="confirmationPageTitle" placeholder="Application Submitted" value={primaryMessage} onChange={(e) => setConfirmationPrimaryMessage(e.target.value)} />
            </div>
          </div>

          {/* Description Section */}
          <div className="flex flex-col gap-2 mt-2">
            <label htmlFor="confirmationPageDescription" className="text-xs font-medium text-foreground">Description</label>
            <RichTextEditor
              placeholder="You have successfully submitted your application to My Fashion Brand’s campaign. Visit the Aspire Creator Marketplace to apply to more campaigns."
              value={description}
              onChange={setConfirmationDescription}
              className="[&_.ql-editor]:min-h-[120px]"
            />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
